<template>
	<section>
		<div class="planner-times" v-for="(startTime, startTimeIndex) in eventData.startTimes" :key="startTimeIndex">

			<div class="planner-time">
				{{ startTime.time.split(' ')[0] }}<span class="time-ampm"> {{ startTime.time.split(' ')[1] }}</span>
			</div>

			<div class="planner-entry" v-for="(activity, activityIndex) in startTime.activities" :key="activityIndex" :class="{ 'card-danger': activity.isCanceled }">
				<div class="planner-row">
					<div class="planner-col-md-3">
						<div class="planner-entry-title">
							<span class="text-danger" v-if="activity.isCanceled">Canceled </span>
							<a :href="`${classDetailsUrl}?eventId=${activity.id}`">
								<span v-if="activity.isCanceled"><s>{{ activity.name }}</s></span>
								<span v-else>{{ activity.name }}</span>
							</a>
							<span v-if="activity.isPaidClass"><span class="ico-pay mylt-green"></span><span class="sr-only"> (paid class)</span></span>
						</div>
					</div>
					<div class="planner-col-md-2 font-weight-bold" v-html="parseTimes(startTime.time, activity.endTime)"></div>
					<div class="planner-col-md-2">
						<span v-if="activity.instructors && activity.instructors.length > 0" v-html="buildInstructors(activity.instructors)"></span>
					</div>
					<div class="planner-col-md-3">
						{{ activity.location }}
					</div>
					<div class="planner-entry-cta planner-col-md-2">
						<a :href="`${classDetailsUrl}?eventId=${activity.id}`" v-if="activity.isRegistrable && !activity.isCanceled && startTime.timestamp > now">Reserve</a>
						<!-- TODO: Switch to this markup once schedules/brief endpoint is updated to add CTA -->
						<!-- <a :href="`${classDetailsUrl}?eventId=${activity.id}`" v-if="startTime.timestamp > now">{{ activity.cta }}</a> -->
					</div>
				</div>
			</div>

			<p v-if="startTime.activitiesOmitted" class="p-x-1 p-y-0 m-b-0 text-truncate">
				<a :href="fullScheduleUrl" class="text-muted nano">{{ startTime.activitiesOmitted }} more class<span v-if="startTime.activitiesOmitted > 1">es</span> starting at {{ startTime.time.split(' ')[0] }}<span class="time-ampm"> {{ startTime.time.split(' ')[1] }}</span></a>
			</p>

		</div>

		<div v-if="!hasStartTimes && !isWaiting">
			<div class="planner-entry">No more classes scheduled for today.</div>
		</div>

		<div class="small m-x-1 m-y-sm" :class="{'planner-times': hasStartTimes}"><a :href="fullScheduleUrl">View Full Schedule</a></div>
	</section>
</template>

<script>
import _ from 'lodash';
import { defineComponent } from 'vue';
import { baseComponentMixin } from '@/mixins/baseComponent.mixin';
import { UxSchedulesApi } from '@/apis/uxSchedules.api';
import { FrameworkService } from '@/services/framework.service';
import { StateService } from '@/services/state.service';
import { Helpers } from '@/common/helpers';
import { clockObservable$, dateProvider } from '@/services/clock.service';

let clockSubscription;

export default defineComponent({
	name: 'ClassSchedulesBriefComponent',
	config: {
		key: 'schreg.classSchedulesBrief',
		devPath: 'class-schedules-brief',
		exported: true
	},
	mixins: [
		baseComponentMixin
	],
	data() {
		return {
			eventData: {},
			fullScheduleUrl: '',
			classDetailsUrl: '',
			hasStartTimes: false,
			now: dateProvider()
		};
	},
	created() {
		clockSubscription = clockObservable$
			.subscribe(m => {
				this.now = m;
			});
	},
	mounted() {
		this.getFrameworkData(this.completeMounting, ['ClubStore', 'UrlStore', 'ProfileStore']);
	},
	destroyed() {
		clockSubscription.unsubscribe();
	},
	methods: {
		completeMounting() {
			this.fullScheduleUrl = FrameworkService.clubUrl('classes');
			this.classDetailsUrl = FrameworkService.clubUrl('classDetails');
			this.loadClasses();
		},
		loadClasses() {
			let tags = [];
			if (StateService.authoredSettings.preselectedClassNames) {
				if (StateService.authoredSettings.preselectedClassNames instanceof Array) {
					_.forEach(StateService.authoredSettings.preselectedClassNames, function(className) {
						tags.push('departmentDescription:' + className);
					});
				} else {
					tags.push('departmentDescription:' + StateService.authoredSettings.preselectedClassNames);
				}
			}
			UxSchedulesApi.searchClassesBrief(tags).then(response => {
				if (!response.ok) {
					// TODO: error handling
					return;
				}
				this.eventData = {
					startTimes: response.data.startTimes
				};
				this.hasStartTimes = this.eventData.startTimes && this.eventData.startTimes.length > 0;
				this.isWaiting = false;
			});
		},
		buildInstructors(instructors) {
			return Helpers.buildInstructors(instructors);
		},
		parseTimes(startTime, endTime) {
			return Helpers.parseTimes(startTime, endTime);
		}
	}
});
</script>

<style lang="scss" scoped>
.planner {
	padding-bottom: 0;
}
.planner-time {
	top: 0;
}
.planner-entry {
	min-height: 0;
}
</style>
